/* AVISTAR PDP: adds per-unit price + "Save X%" to Dawn's pack-size pills.
   Reads the leading number in each variant title as the pack count.
   Non-destructive: only appends to existing Dawn labels, never rewrites the form. */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function enhance(scope) {
    var hosts = (scope || document).querySelectorAll('[data-av-packs]');
    if (!hosts.length && scope && scope !== document) {
      hosts = document.querySelectorAll('[data-av-packs]');
    }
    [].forEach.call(hosts, function (host) {
      var variants;
      try {
        variants = JSON.parse(host.getAttribute('data-variants') || '[]');
      } catch (e) {
        return;
      }
      if (!variants.length) return;

      var packs = variants.map(function (v) {
        var m = (v.t || '').match(/(\d[\d,]*)/);
        var count = m ? parseInt(m[1].replace(/,/g, ''), 10) : 1;
        if (!count) count = 1;
        return { title: v.t, price: v.p, count: count, pu: v.p / count };
      });
      // Smallest pack has the dearest per-unit; everything else saves against it.
      var base = Math.max.apply(null, packs.map(function (p) { return p.pu; }));

      var form = host.closest('.product__info-container') || document;
      var inputs = form.querySelectorAll('.product-form__input--pill input[type="radio"]');
      if (!inputs.length) {
        inputs = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
      }
      [].forEach.call(inputs, function (inp) {
        var p = null;
        for (var i = 0; i < packs.length; i++) {
          if (packs[i].title === inp.value) { p = packs[i]; break; }
        }
        if (!p) return;
        var label = (form.querySelector('label[for="' + inp.id + '"]')) ||
                    document.querySelector('label[for="' + inp.id + '"]');
        if (!label || label.querySelector('.av-pu')) return;

        var save = Math.round((1 - (p.pu / base)) * 100);
        var span = document.createElement('span');
        span.className = 'av-pu';
        span.innerHTML = money(p.pu) + '/ea' + (save > 0 ? ' <b>Save ' + save + '%</b>' : '');
        label.appendChild(span);
      });
    });
  }

  if (document.readyState !== 'loading') {
    enhance(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  }
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });
})();
